import React, { useEffect, useState } from 'react';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string | undefined;
    fallbackSrc: string | undefined;
}

const ImageWithFallback = React.forwardRef<HTMLImageElement, ImageWithFallbackProps>(function ImageWithFallback(
    { src, fallbackSrc, onError, ...props },
    ref
) {
    const [imgSrc, setImgSrc] = useState(src);

    useEffect(() => {
        setImgSrc(src);
    }, [src]);

    return (
        /* eslint-disable-next-line jsx-a11y/alt-text */
        <img
            {...props}
            ref={ref}
            src={imgSrc}
            onError={(e) => {
                if (fallbackSrc && imgSrc !== fallbackSrc) {
                    setImgSrc(fallbackSrc);
                }

                if (onError) {
                    onError(e);
                }
            }}
        />
    );
});

export default ImageWithFallback;
